import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

import Loader from "./elements/Loader"
import Sidebar from "./Sidebar"
import SearchBanner from "./SearchBanner"
import Toolbar from "./Toolbar"
import Products from "./Products"
import LoadMore from "./LoadMore"
import NoResults from "./NoResults"

export default function Serp() {
    const { response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const [ sortOpen, setSortOpen ] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen);
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    useEffect(() => {
        (sidebarOpen)
            ?   document.body.classList.add("overflow-hidden")
            :   document.body.classList.remove("overflow-hidden")
    }, [ sidebarOpen ])

    return (
        <div class="ns-serp" data-nosto-element="search">
            {foundProducts && (
                <>
                    <Sidebar
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                    <SearchBanner />
                    <Toolbar
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                        sortOpen={sortOpen}
                        toggleSort={toggleSort}
                    />
                </>
            )}
            <div class="ns-serp-inner">
                {(loading && !foundProducts) ? (
                    <Loader />
                ) : (foundProducts) ? (
                    <>
                        <Products />
                        <LoadMore />
                    </>
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    );
};